module.exports = "/images/logo/logo.svg";